/* social-proof-spence - minimal JS, runs once */
(function () {
  if (window.__spenceInit) return; window.__spenceInit = true;
  function init() {
    var bar = document.getElementById('spence-stickybar');
    var hero = document.getElementById('spence-top');
    var offer = document.getElementById('offer');
    var offerInView = false;
    function updateBar() {
      if (!bar || !hero) return;
      var pastHero = hero.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('spc-show', pastHero && !offerInView);
    }
    if (offer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { offerInView = e[0].isIntersecting; updateBar(); },
        { threshold: 0.12 }).observe(offer);
    }
    window.addEventListener('scroll', updateBar); updateBar();
    document.querySelectorAll('.spc-faq-q').forEach(function (q) {
      q.addEventListener('click', function () { q.parentElement.classList.toggle('spc-open'); });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
